export default {
  //  --------------------- 联交运银行开始 (40)-------------
  // 出金
  param_outFund: {
    url: 'ljy-bank-channel/fund/outFund',
    param: {
      bankId: 40,
      amount: 0, // 出金金额
      pwd: '' // 资金密码
    }
  },
  // 他行入金展示信息
  param_showInFundInfo40: {
    url: '/ljy-bank-channel/fund/showInFundInfo',
    param: {}
  },
  // 本行入金
  param_inFundOurBank: {
    url: '/ljy-bank-channel/fund/inFundOurBank',
    param: {
      transAmt: '',
      pwd: '', // 资金密码
      memo: '' // 备注
    }
  }
//  --------------------- 联交运银行结束-------------
}
